import {
    NinchatActionType,
    NinchatJoinPermissionGroupAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
    NinchatClientPromiseValue,
} from '../NinchatClient'
import {NinchatProperties} from 'api/types'

import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export type JoinPermissionGroupParams = NinchatActionParams<NinchatJoinPermissionGroupAction> & {
    realm_id: NinchatProperties.RealmID
}

export const joinPermissionGroup = createAsyncThunk<NinchatClientPromiseValue, JoinPermissionGroupParams>(
    `${actionTypePrefix}/${NinchatActionType.NinchatJoinPermissionGroupAction}`,
    async (arg: JoinPermissionGroupParams, {rejectWithValue}) => {
        const params: NinchatActionParams<NinchatJoinPermissionGroupAction> = {permission_group_id: arg.permission_group_id}

        params.action = NinchatActionType.NinchatJoinPermissionGroupAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
